module.exports = "/images/grid-logos.png";